import InactivityTracker from '../utils/inactivityTracker.js'
import saveUserInLocalData from './saveUserInLocalData.js'

async function isAuthenticated(context) {
  try {
    const { localRepo } = context
    const userData = await localRepo.get()
    if (!userData?.id) return false

    // Vérifier si la session a expiré après 2h d'inactivité
    if (InactivityTracker.isExpired()) {
      console.warn('isAuthenticated: Session expirée après 2h d’inactivité.')
      InactivityTracker.clear()
      await localRepo.delete()
      await saveUserInLocalData(context)
      return false
    }

    return true
  } catch (error) {
    console.log('🚀 ~ isAuthenticated ~ error:', error)
    return false
  }
}

export default isAuthenticated

